import { useEffect } from 'react';

export default function PwaRegistration() {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return undefined;
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return undefined;

    let isCancelled = false;
    let loadHandler = null;

    const registerServiceWorker = async () => {
      if (isCancelled) return;

      try {
        const registration = await navigator.serviceWorker.register('/sw.js', {
          scope: '/',
        });

        registration.update().catch(() => {});

        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      } catch (error) {
        console.warn('Service worker registration failed:', error);
      }
    };

    if (document.readyState === 'complete') {
      registerServiceWorker();
    } else {
      loadHandler = () => {
        registerServiceWorker();
      };
      window.addEventListener('load', loadHandler, { once: true });
    }

    return () => {
      isCancelled = true;
      if (loadHandler) {
        window.removeEventListener('load', loadHandler);
      }
    };
  }, []);

  return null;
}
